import {
    CREATE_SUBSCRIPTION_REQUEST,
    CREATE_SUBSCRIPTION_SUCCESS,
    CREATE_SUBSCRIPTION_FAILURE,
    DELETE_SUBSCRIPTION_REQUEST,
    DELETE_SUBSCRIPTION_SUCCESS,
    DELETE_SUBSCRIPTION_FAILURE,
    FETCH_SUBSCRIPTIONS_REQUEST,
    FETCH_SUBSCRIPTIONS_SUCCESS,
    FETCH_SUBSCRIPTIONS_FAILURE,
  } from './types.js';
  import {
    
    createSubscriptionType,
    deleteSubscriptionType,
  } from '../../services/subscriptions.services';
  
  import {
    getAllSubscriptionsType,
    getAllSubscriptions,
    getMySubscriptions,
  } from "../../user/services/subscriptions.services.js";
  export const GET_SUBSCRIPTION_TYPES = "GET_SUBSCRIPTION_TYPES";
  export const GET_ALL_SUBSCRIPTIONS = "GET_ALL_SUBSCRIPTIONS";
  export const GET_MY_SUBSCRIPTIONS = "GET_MY_SUBSCRIPTIONS";
  export const LOGOUT = "LOGOUT";
  

  export const fetchSubscriptions = () => async (dispatch) => {
    dispatch({ type: FETCH_SUBSCRIPTIONS_REQUEST });
    try {
      const response = await getAllSubscriptionsType(
        JSON.parse(sessionStorage.getItem("myData"))
      );
      dispatch({
        type: FETCH_SUBSCRIPTIONS_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_SUBSCRIPTIONS_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const createSubscription = (subscriptionData) => async (dispatch) => {
    dispatch({ type: CREATE_SUBSCRIPTION_REQUEST });
    try {
      const response = await createSubscriptionType(
        subscriptionData,
        JSON.parse(sessionStorage.getItem("myData"))
      );
      dispatch({
        type: CREATE_SUBSCRIPTION_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_SUBSCRIPTION_FAILURE,
        payload: error.message,
      });
    }
  };
  
  export const deleteSubscription = (subscriptionId) => async (dispatch) => {
    dispatch({ type: DELETE_SUBSCRIPTION_REQUEST });
    try {
      const response = await deleteSubscriptionType(
        subscriptionId,
        JSON.parse(localStorage.getItem("myData"))
      );
      dispatch({
        type: DELETE_SUBSCRIPTION_SUCCESS,
        payload: subscriptionId,
      });
    } catch (error) {
      dispatch({
        type: DELETE_SUBSCRIPTION_FAILURE,
        payload: error.message,
      });
    }
  };

  export const GetAllSubscriptionTypeAction = () => {
    return async (dispatch, getState) => {
      const {
        authReducer: { user },
      } = await getState();
      try {
        let result = await getAllSubscriptionsType(user?.token);
        dispatch({
          type: GET_SUBSCRIPTION_TYPES,
          payload: result.data,
        });
      } catch (e) {
        console.log("error in  getAllSubscriptionsType =====>>!!");
      }
    };
  };
  
  export const GetAllSubscriptionAction = () => {
    return async (dispatch, getState) => {
      const {
        authReducer: { user },
      } = await getState();
      try {
        let result = await getAllSubscriptions(user?.token);
        dispatch({
          type: GET_ALL_SUBSCRIPTIONS,
          payload: result.data,
        });
      } catch (e) {
        console.log("error in  GetAllSubscriptionAction =====>>", e);
      }
    };
  };
  
  export const GetMySubscriptionAction = (data) => {
    return async (dispatch, getState) => {
      const {
        authReducer: { user },
      } = await getState();
      try {
        let result = await getMySubscriptions(data, user?.token);
        dispatch({
          type: GET_MY_SUBSCRIPTIONS,
          payload: result.data,
        });
      } catch (e) {
        console.log("error in  GetMySubscriptionAction =====>>", e);
      }
    };
  };
  
  